import * as React from "react"
import Button from "@mui/material/Button"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import MenuIcon from "@mui/icons-material/Menu"
import { RootState } from "@/core/app/store"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { UASSIST_STATUS } from "@/core/constants/UassistStatus"
import {
  setCurLeftPage,
  setUassistRxShow,
  setReuploadSelfPlan,
} from "../udTreatSlice"
import { checkIsThereASpecifiedPhoto } from "../left/utils"
import { openRefinement } from "@/core/app/slices/clinical/refinement/refinementThunkApi"
import { usePrintAccess } from "@/hooks/feature-flags/usePrintAccess"
import {
  orderButtonPopUpTmp,
  refinementToSubmitToUassistDisabled,
} from "../bottom/Toggle/column"
export default function MenuButtons({
  onClickPrint,
  clickUseUassist,
  clickRefinementUassist,
  clickSelfRefinement,
}) {
  const isPrintEnabled = usePrintAccess()
  const dispatch = useAppDispatch()
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const {
    caseDisposition,
    upperType,
    lowerType,
    udesign_category,
    uassist_progress,
    is_printable,
    is_orderable,
    is_self_planned_enable,
  } = caseDetail
  const {
    isCasePreview,

    curRightPage,
  } = useAppSelector((state: RootState) => state.udTreatService)
  const { photoTypeJson } = useAppSelector(
    (state: RootState) => state.PhotosService,
  )

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  // Calculate if any menu item should be visible
  const shouldShowUseExistingUassist =
    !(
      orderButtonPopUpTmp.includes(caseDisposition) ||
      !caseDetail.is_existing_plan_uassist_possible
        )

  const shouldShowRefinementUassist =
    !(
      orderButtonPopUpTmp.includes(caseDisposition) ||
      refinementToSubmitToUassistDisabled.includes(caseDisposition)
    )

  const shouldShowSelfRefinement =
    !(
      isCasePreview ||
      !is_self_planned_enable
    )

  const shouldShowExportSTL =
    isPrintEnabled &&
    !(isCasePreview || curRightPage ? true : !is_printable)

  const isExportSTLDisabled = isCasePreview || curRightPage ? true : !is_printable

  const hasAnyVisibleMenuItem =
    shouldShowUseExistingUassist ||
    shouldShowRefinementUassist ||
    shouldShowSelfRefinement ||
    shouldShowExportSTL

  return (
    <div>
      <Button
        className="menuTop"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        // Disable button when all menu items are hidden instead of hiding the button entirely
        disabled={!hasAnyVisibleMenuItem}
        sx={{
          zIndex: 1,
          width: 40,
          height: 40,
          borderRadius: "50%",
          minWidth: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.85);",
          boxShadow:
            "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
          ":hover": {
            backgroundColor: "rgba(245, 245, 245, 0.96);",
            boxShadow:
              "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
          },
          ":disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.12)",
          },
          "&:disabled svg": {
            color: "black",
            opacity: 0.38,
          },
        }}
      >
        <MenuIcon
          sx={{
            color: "black",
            opacity: 0.87,
          }}
        />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
        sx={{
          "& .MuiPaper-root": {
            marginTop: "4px",
          },
        }}
      >
        {shouldShowUseExistingUassist && (
          <MenuItem
            disabled={!shouldShowUseExistingUassist}
            onClick={() => {
              // submit to uassist
              clickUseUassist()
              handleClose()
            }}
          >
            Use Existing Scan/Plan - Submit to uAssist
          </MenuItem>
        )}

        {shouldShowRefinementUassist && (
          <MenuItem
            disabled={!shouldShowRefinementUassist}
            onClick={() => {
              clickRefinementUassist()
              handleClose()
            }}
          >
            Refinement - Submit to uAssist
          </MenuItem>
        )}

        {shouldShowSelfRefinement && (
          <MenuItem
            disabled={!shouldShowSelfRefinement}
            onClick={() => {
              clickSelfRefinement()
              handleClose()
            }}
          >
            Refinement - Self Planned
          </MenuItem>
        )}

        {shouldShowExportSTL && (
          <MenuItem
            // 1. if case is preview or right tool page is open, disable print button
            // 2. if case is not preview, check the permission from backend to enable or disable print button
            disabled={isExportSTLDisabled}
            onClick={() => {
              onClickPrint()
              handleClose()
            }}
          >
            Export STL
          </MenuItem>
        )}

        {/* <MenuItem
          onClick={() => {
            dispatch(
              setReuploadSelfPlan({
                isReuploadSelfPlan: true,
              }),
            )
            handleClose()
          }}
        >
          Replace STL
        </MenuItem> */}
      </Menu>
    </div>
  )
}
